import instance from "../../api";

export const getRealEstates = () => {
  return instance().post('/dictionary/realEstatesLimit20', {}).then(response => response.data);
};

export const getSurveyQuestions = () => {
  return instance().post('/dictionary/surveyQuestions', {}).then(response => {
    let result = response.data;
    // @ts-ignore
    result.forEach((el) => {
      el.selected = false;
    });
    return result;
  });
};

export const saveSurvey = (data: any) => {
  return instance().post('/survey/save', data).then(response => console.log(response));
}